import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69f7be16f6558f00141c5d0c/wbosorga/src/app/consultant-login/page.tsx");
